import { ProductVariationValidSyntax } from 'models/productsReferential';

export type EssentialWorkspaceTabActions = ReturnType<
  (typeof essentialWorkspaceTabActions)[keyof typeof essentialWorkspaceTabActions]
>;
export const essentialWorkspaceTabActions = {
  toggleUnderlyingsResult: (tabId: string) => ({
    type: 'ESSENTIAL_WORKSPACE_TAB_TOGGLE_UNDERLYINGS_RESULT' as const,
    tabId,
  }),
  togglePayoffGraph: (tabId: string) => ({
    type: 'ESSENTIAL_WORKSPACE_TAB_PAYOFF_GRAPH_EXPANDED' as const,
    tabId,
  }),
  updateProductVariation: (tabId: string, productVariation: ProductVariationValidSyntax | undefined) => ({
    type: 'ESSENTIAL_WORKSPACE_TAB_UPDATE_PRODUCT_VARIATION' as const,
    tabId,
    productVariation,
  }),
  setQuote: (tabId: string, quoteId: string) => ({
    type: 'ESSENTIAL_WORKSPACE_SET_QUOTE' as const,
    tabId,
    quoteId,
  }),
};
